import { useDispatch, connect } from "react-redux";
import { NotificationManager } from "react-notifications";

import { positionsActions, devicesActions } from "./store";
import { useEffectAsync } from "./reactHelper";
import Conf from "../conf";

const RetryInterval = 10 * 1000;
let interval;
const Socket = () => {
    const Dispatch = useDispatch();

    const ConnectSocket = (Try = 0) => {
        if (Try !== 0) {
            NotificationManager.error("خطا در ارتباط با سرور", "لطفا وضعیت اینترنت خود را برسی کنید", RetryInterval);
        }
        const Connection = new WebSocket("wss://radyabe.ir/api/socket");

        Connection.onopen = () => {
            Try = 0;
        };

        Connection.onmessage = (event) => {
            const data = JSON.parse(event.data);

            if (data.devices) {
                Dispatch(devicesActions.update(data.devices));
            } else if (data.positions) {
                Dispatch(positionsActions.update(data.positions));
            }
        };

        Connection.onclose = () => {
            if (interval) clearTimeout(interval);
            interval = setTimeout(() => ConnectSocket(++Try), RetryInterval);
        };

        Connection.onerror = (Error) => {
            if (interval) clearTimeout(interval);
            interval = setTimeout(() => {
                ConnectSocket(++Try);
            }, RetryInterval);
        };
    };

    useEffectAsync(async () => {
        let response = await fetch(`${Conf.server_address}/devices`, { method: "GET", credentials: "include" });
        if (response.ok) {
            Dispatch(devicesActions.refresh(await response.json()));
            ConnectSocket();
        }
    }, []);

    return null;
};

export default connect()(Socket);
